// extracted by mini-css-extract-plugin
export var bodyRow = "_ew-d";
export var cardColumns = "_ew-e";
export var ellipsesOverflow = "_ew-2";
export var flatBottomCorners = "_ew-3";
export var flatTopCorners = "_ew-4";
export var headerActionsDropdown = "_ew-f";
export var headerBottomRow = "_ew-c";
export var headerTopRow = "_ew-b";
export var orderDetailsWrapper = "_ew-0";
export var orderInfoContainer = "_ew-1";
export var productDetails = "_ew-9";
export var productImage = "_ew-5";
export var responsiveTable = "_ew-8";
export var shipmentContainer = "_ew-a";
export var tableBottomLeft = "_ew-6";
export var tableBottomRight = "_ew-7";
export var trackingLink = "_ew-g";